import React, { useEffect } from "react";
import { useDispatch } from "react-redux";

// layouts
import { MainLayout } from "layouts";

// components
import { AccountOverview } from "components/all/settings";

// redux
import { fetchUserInfo } from "redux/slices/user/userSlice";

const AccountSettings = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchUserInfo());
  }, []);

  return (
    <MainLayout
      withBottomTab={false}
      withHeader={true}
      backgroundColor="white"
      headerProps={{ withBackButton: true, centerTitle: "관리자 계정 설정" }}
    >
      <AccountOverview />
    </MainLayout>
  );
};

export default AccountSettings;
